"use strict";

import $ from 'jquery';
import ForgotPassword from './forgot-password';

function loginClick() {
    $('.login-toggle, .login-close').removeClass('open').off('click');
    if ( $('.login').css('display') == "none" ) {
        $('.login-toggle, .login-close').on('click', function(e){
            e.preventDefault();
            $('.login').toggleClass('open');
        });
    } else {
        $('.login-toggle, .login-close').removeClass('open').off('click');
    }
}

// Smooth anchor scrolling
function goToByScroll(id) {
    $('html,body').animate({scrollTop: ($("#"+id).offset().top - 100)},1500);
}

// Add margin when alert is open
function checkProgressView() {
    var activateClick = false;

    if( $('.secondary-section-content').css('display') == "none") {
        activateClick = true;
    } else {
        activateClick = false;
    }

    return activateClick;
}

function progressClick() {
    $('.secondary-section').removeClass('open').off('click');

    var activateClick = checkProgressView();

    if( activateClick ) {
        $('.secondary-section').on('click', function(){
            $(this).toggleClass('open');
        });
    } else if ( !activateClick ) {
        $('.secondary-section').removeClass('open').off('click');
    }
}

/*
 If the banner is present, the page needs to be adjusted down to accomodate
 */
function adjustPageForAlert() {
    const alertElem = '.page-alert';
    var alertHeight = $(alertElem).outerHeight();
    $('#page-header, .content-wrap').css( 'margin-top', alertHeight );
}

/**
 * When the logged in SSO account is not associated with a student account,
 * below function will show the Username-notfound-modal modal.
 */
function showUserNameNotFoundModal() {
    if(window.userNameNotFound) {
        $("#Username-notfound-modal").modal('show');
    }
}

/**
 When the SSO account is not associated with a student account, user
 is logged out and taken to the SSO login page.
 */
function logoutAndShowLoginFormWhenClicked() {
    $('#Username-notfound-modal').on('hide.bs.modal', function() {
        $("#non-student-log-out-form").submit();
    });
}

document.addEventListener("DOMContentLoaded", function() {

    // Jump button
    $('.jump-btn').on('click', function(e){
        e.preventDefault();
        goToByScroll('start');
    });

    // Account creation mobile toggle
    progressClick();
    $(window).resize( function(){
        progressClick();
    });

    // Page alert
    if ( $('body').hasClass('alert-open') ) {

        window.setTimeout(adjustPageForAlert, 200);

        $(window).resize( function(){
            adjustPageForAlert();
        } );
    }

    // Login dropdown
    loginClick();
    $(window).resize( function(){
        loginClick();
    });

    showUserNameNotFoundModal();
    logoutAndShowLoginFormWhenClicked();

    // 2023_02_08: User should be taken to the SSO Reset Password page.
    //ForgotPassword.init('#forgot-password-modal', '#forgot-password', '#forgot-password-modal-has-code');
});


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/index/index-page.js